import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { LocalStorageService } from '../core/services/local-storage.service';

/**
 * Adds language query param when calling endpoints:
 *  - language (localStorage → default 'en')
 */
export const LangParamsInterceptor: HttpInterceptorFn = (req, next) => {
  const localStorageService = inject(LocalStorageService);
  const language: string = localStorageService.get('language') || 'en';

  const hasLangInParams = req.params.has('language') || req.params.has('lang');
  const hasLangInUrl =
    req.url.includes('language=') || req.url.includes('lang=');

  if (hasLangInParams || hasLangInUrl) {
    return next(req);
  }

  const setParams: Record<string, string> = { language };
  return next(req.clone({ setParams }));
};
